export enum GraphQLComparision {
  EQUAL,
  NOT_EQUAL,
  GREATER_THAN,
  GREATER_THAN_OR_EQUAL,
  LESS_THAN,
  LESS_THAN_OR_EQUAL,
  CONTAINS,
  DOES_NOT_CONTAIN,
  STARTS_WITH,
  ENDS_WITH,
  IN,
  LIKE,
  NOT_IN,
  LAST,
  IS_DESCENDANT_OF
}
